import i18next from 'i18next';
import { useTranslation as usei18nextTranslation } from 'react-i18next';

const NAMESPACE = 'GENERAL';

i18next.addResources('es', NAMESPACE, {
  SEARCH: 'Buscar',
  CANCEL: 'Cancelar',
  ACCEPT: 'Aceptar',
  CONFIRM: 'Confirmar',
  CONTINUE: 'Continuar',
  DOWNLOAD: 'Descargar',
  CONFIRMATION: 'Confirmación',
  ERROR: 'Error',
  ERROR_MESSAGE:
    'Ha ocurrido un error. No se pudo completar la acción solicitada.',
  ERROR_ID: '{{message}} ID: {{id}}',
  EDIT: 'Editar',
  DELETE: 'Borrar',
  ELIMINATE: 'Eliminar',
  YESTERDAY: 'Ayer',
  TOMORROW: 'Mañana',
  MINUTES: 'minutos',
  TODAY: 'Hoy',
  SEND: 'Enviar',
  SAVE: 'Guardar',
  SAVING: 'Guardando',
  LOADING_SEND: 'Enviando',
  CLOSE: 'Cerrar',
  BACK: 'Atrás',
  NEXT: 'Siguiente',
  PREVIOUS: 'Anterior',
  FINISH: 'Finalizar',
  CREATE: 'Crear',
  LOADING_CREATE: 'Creando',
  SEE_MORE: 'ver más',
  SEE_LESS: 'ver menos',
  DROP_FILE: 'Suelte el archivo aquí',
  ERROR_DRAG_AND_DROP: 'Error al intentar subir el archivo',
  RETRY: 'Reintentar',
  RESEND: 'Reenviar',
  ERROR_GENERAL: 'Ocurrió un error',
  ERROR_GENERAL_RETRY: 'Ocurrió un error, vuelve a intentar más tarde',
  SAVE_CHANGES: 'Guardar cambios',
  START: 'Empezar',
  MORE: 'Más',
  NEW: 'Nuevo',
  ERROR_CONNECTING_NOTIFICATIONS: 'Error al conectar las notificaciones',
  MINIMIZE: 'ocultar',
  ROWS_PER_PAGE: 'Filas por página:',
  VIEW_MORE: 'Ver más',
  VIEW_LESS: 'Ver menos',
  EMPTY: 'Vacío',
  YES: 'Sí',
  NO: 'No',
  SELECT: 'Seleccionar',
  ADD: 'Agregar',
  NAME: 'Nombre',
  LAST_NAME: 'Apellido',
  EMAIL: 'Email',
  FILTER: 'Filtrar',
  APPLY: 'Aplicar',
  GO_BACK: 'Volver',
  COPY: 'copiar',
});

i18next.addResources('en', NAMESPACE, {
  SEARCH: 'Search',
  CANCEL: 'Cancel',
  ACCEPT: 'Accept',
  CONFIRM: 'Confirm',
  CONTINUE: 'Continue',
  DOWNLOAD: 'Download',
  CONFIRMATION: 'Confirmation',
  ERROR: 'Error',
  ERROR_MESSAGE:
    'An error has occurred. The requested action could not be completed.',
  ERROR_ID: '{{message}} ID: {{id}}',
  EDIT: 'Edit',
  DELETE: 'Delete',
  ELIMINATE: 'Remove',
  YESTERDAY: 'Yesterday',
  TOMORROW: 'Tomorrow',
  MINUTES: 'minutes',
  TODAY: 'Today',
  SEND: 'Send',
  SAVE: 'Save',
  SAVING: 'Saving',
  START: 'Start',
  LOADING_SEND: 'Sending',
  CLOSE: 'Close',
  BACK: 'Back',
  NEXT: 'Next',
  PREVIOUS: 'Previous',
  FINISH: 'Finalize',
  CREATE: 'Create',
  LOADING_CREATE: 'Creating',
  SEE_MORE: 'see more',
  SEE_LESS: 'see less',
  DROP_FILE: 'Drop the file here',
  ERROR_DRAG_AND_DROP: 'Failed to upload file',
  RETRY: 'Retry',
  RESEND: 'Resend',
  ERROR_GENERAL: 'An error ocurred',
  ERROR_GENERAL_RETRY: 'An error occurred, please try again later',
  SAVE_CHANGES: 'Save changes',
  MORE: 'More',
  NEW: 'New',
  ERROR_CONNECTING_NOTIFICATIONS: 'Failed to connect notifications',
  MINIMIZE: 'Minimize',
  ROWS_PER_PAGE: 'Rows per page:',
  VIEW_MORE: 'View more',
  VIEW_LESS: 'View less',
  EMPTY: 'Empty',
  YES: 'Yes',
  NO: 'No',
  SELECT: 'Select',
  ADD: 'Add',
  NAME: 'Name',
  LAST_NAME: 'Surname',
  EMAIL: 'Email',
  FILTER: 'Filter',
  APPLY: 'Apply',
  GO_BACK: 'Go back',
  COPY: 'copy',
});

i18next.addResources('pt', NAMESPACE, {
  SEARCH: 'Pesquisar',
  CANCEL: 'Cancelar',
  ACCEPT: 'Aceitar',
  CONFIRM: 'Confirmar',
  CONFIRMATION: 'Confirmação',
  ERROR: 'Erro',
  ERROR_MESSAGE: 'Ocorreu um erro. A ação solicitada não pôde ser concluída.',
  ERROR_ID: '{{message}} ID: {{id}}',
  EDIT: 'Editar',
  DELETE: 'Apagar',
  ELIMINATE: 'Remover',
  YESTERDAY: 'Ontem',
  TOMORROW: 'Manhã',
  MINUTES: 'minutos',
  TODAY: 'Hoje',
  SEND: 'Enviar',
  SAVE: 'Salvar',
  SAVING: 'Salvando',
  START: 'Começar',
  CONTINUE: 'Continuar',
  DOWNLOAD: 'Baixar',
  LOADING_SEND: 'Enviando',
  CLOSE: 'Fechar',
  BACK: 'Voltar',
  NEXT: 'Próximo',
  PREVIOUS: 'Anterior',
  FINISH: 'Finalizar',
  CREATE: 'Criar',
  LOADING_CREATE: 'Criando',
  SEE_MORE: 'ver mais',
  SEE_LESS: 'ver menos',
  DROP_FILE: 'Solte o arquivo aqui',
  ERROR_DRAG_AND_DROP: 'Erro ao carregar o arquivo',
  RETRY: 'Tente novamente',
  RESEND: 'Reenviar',
  ERROR_GENERAL: 'Um erro ocorreu',
  ERROR_GENERAL_RETRY: 'Ocorreu um erro. Por favor tente novamente mais tarde',
  SAVE_CHANGES: 'Guardar mudanças',
  MORE: 'Mais',
  NEW: 'Novo',
  ERROR_CONNECTING_NOTIFICATIONS: 'Falha ao conectar as notificações',
  MINIMIZE: 'ocultar',
  ROWS_PER_PAGE: 'Linhas por página:',
  VIEW_MORE: 'Ver mais',
  VIEW_LESS: 'Ver menos',
  EMPTY: 'Vazio',
  YES: 'Sim',
  NO: 'Não',
  SELECT: 'Selecione',
  ADD: 'Adicionar',
  NAME: 'Nome',
  LAST_NAME: 'Sobrenome',
  EMAIL: 'Email',
  FILTER: 'Filtrar',
  APPLY: 'Aplicar',
  GO_BACK: 'Voltar',
  COPY: 'copiar',
});

export const useTranslation = () =>
  usei18nextTranslation([NAMESPACE, 'GENERAL']);
